// i18next bootstrap. Three locales: EN, FR, HT (Kreyòl).
//
// Default detection order:
//   1. localStorage (manual switch sticks across sessions)
//   2. navigator.language (browser locale)
//   3. fallback to EN
//
// Diaspora users typically land in EN; HT recipients on the PWA will
// fall through navigator.language to HT or FR; FR-speakers fall through
// to FR. Manual override via the <LanguageSwitcher> in the header.

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import ht from '../locales/ht.json';

export const SUPPORTED_LOCALES = ['en', 'fr', 'ht'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ht: { translation: ht },
    },
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'lakaycart_lang',
      caches: ['localStorage'],
    },
    // Don't suspense — we ship all 3 translation files in the main bundle
    // (they're tiny), so the initial render has everything available.
    react: { useSuspense: false },
  });

export default i18n;
